import { Formik } from 'formik';
import { useContext, useState } from 'react';
import { Button, Form, Modal } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { LoadingButton } from '../../../components/CompUtils';
import ErrorMsg from '../../../components/CompUtils/ErrorMsg';
import { setNotification } from '../../../components/GlobalFeedback/feedbackSlice';
import { CVSeccionMap } from '../../../utils';
import { editItem, newItem } from '../cvSlice';
import { SeccionContext } from '../itemTypes';
import './FormStyles.css';

const FormikContainer = ({
  seccionKey,
  seccionTitle,
  schema,
  initialValues = {},
  children,
  size = 'md',
}) => {
  const dispatch = useDispatch();
  const formState = useContext(SeccionContext);

  const pk = CVSeccionMap[seccionKey].pk;

  const [errorMsg, setErrorMsg] = useState('');

  const notif = {
    timeout: 750,
    msg: 'Operación exitosa',
    variant: 'success',
  };

  const handleClose = (onClose) => {
    //300ms de demora en terminar la animación de cierre del modal
    setTimeout(() => {
      onClose();
    }, 301);
    setErrorMsg('');
    formState.handleClose();
  };

  const submitHandler = (values, actions) => {
    const action = values[pk] !== '' ? editItem : newItem;

    const data = {
      msg: 'Guardando datos...',
      seccionKey,
      itemId: values[pk],
      data: values,
    };
    dispatch(action(data)).then((action) => {
      if (action.error) {
        setErrorMsg('Error al intentar guardar el item');
      } else {
        handleClose(actions.resetForm);
        dispatch(setNotification(notif));
      }
    });
  };

  //Por cada campo en el schema, defino su valor como string vacio o falso segun corresponda
  //Salvo que esté definido en el estado de la sección
  const DefaultInitial = Object.keys(schema.fields).reduce((acu, cur) => {
    return {
      [cur]:
        schema.fields[cur].describe().type === 'boolean'
          ? formState.initialValues[cur] || false
          : formState.initialValues[cur] || '',
      ...acu,
    };
  }, {});

  const initial = {
    ...DefaultInitial,
    ...initialValues,
  };

  return (
    <Formik
      enableReinitialize
      validationSchema={schema}
      onSubmit={submitHandler}
      validateOnChange={false}
      initialValues={initial}>
      {(formik) => (
        <Form noValidate id={seccionKey} onSubmit={formik.handleSubmit}>
          <Form.Control
            type="hidden"
            name="id"
            value={formik.values[pk]}
            onBlur={formik.handleBlur}
            onChange={formik.handleChange}
          />
          <Modal
            dialogClassName="my-modal"
            show={formState.show}
            onHide={() => handleClose(formik.resetForm)}
            size={size}>
            <Modal.Header closeButton>
              <Modal.Title as="h5">
                {formState.formTitle} {seccionTitle}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              {children(formik)}
              <ErrorMsg msg={errorMsg} />
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={() => handleClose(formik.resetForm)}>
                Cancelar
              </Button>
              <LoadingButton isLoading={false} variant="success" onClick={formik.handleSubmit}>
                Guardar
              </LoadingButton>
            </Modal.Footer>
          </Modal>
        </Form>
      )}
    </Formik>
  );
};

export default FormikContainer;
